<script lang="ts">
  import BrandMark from '../shared/BrandMark.svelte';
  import Button from '../shared/Button.svelte';
  import ThemeToggle from '../shared/ThemeToggle.svelte';
</script>

<header class="header">
  <div class="header-inner">
    <BrandMark href="#top" />
    <nav class="nav" aria-label="Primary">
      <a class="nav-link" href="#problem">Why</a>
      <a class="nav-link" href="#innovations">Features</a>
      <a class="nav-link" href="#level0">Privacy</a>
      <a class="nav-link" href="#compare">Compare</a>
    </nav>
    <div class="header-actions">
      <ThemeToggle />
      <Button href="/demo" variant="primary" size="md">Launch the app</Button>
    </div>
  </div>
</header>

<style>
  .header {
    position: sticky;
    top: 0;
    z-index: var(--z-fixed);
    background: color-mix(in oklab, var(--bg) 80%, transparent);
    backdrop-filter: blur(20px) saturate(160%);
    -webkit-backdrop-filter: blur(20px) saturate(160%);
    border-bottom: 1px solid var(--border);
    transition: background var(--t);
  }
  :global([data-theme='brutalist']) .header {
    background: var(--bg);
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-bottom: 2px solid var(--text);
  }
  .header-inner {
    max-width: var(--max-w);
    margin: 0 auto;
    padding: 14px var(--gutter);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  @media (max-width: 640px) {
    .header-inner {
      padding: 12px var(--gutter-sm);
    }
  }
  .nav {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .nav-link {
    padding: 8px 14px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-2);
    text-decoration: none;
    border-radius: var(--radius-sm);
    transition:
      color var(--t),
      background var(--t);
  }
  .nav-link:hover {
    color: var(--text);
    background: var(--bg-card);
  }
  :global([data-theme='brutalist']) .nav-link {
    font-weight: 700;
  }
  :global([data-theme='brutalist']) .nav-link:hover {
    background: var(--accent-dim);
  }
  @media (max-width: 768px) {
    .nav-link {
      display: none;
    }
  }
  .header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
</style>
